/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// CoreUI
require("@coreui/coreui");

require("../bootstrap");
require("../plugins");
require("./lib/fabric-overrides");
require("multiple-select")
require("./lib/no-scroll")
require("bootstrap-toggle")
import "alpinejs";

axios.interceptors.request.use((config) => {
  if (window.__EMBED_TOKEN__) {
    config.headers['X-Embed-Token'] = window.__EMBED_TOKEN__;
  }
  return config;
});

function getBox(width, height) {
  return {
    string: "+",
    style: "font-size: 1px; padding: " + Math.floor(height / 2) + "px " + Math.floor(width / 2) + "px; line-height: " + height + "px;"
  }
}

console.image = function (url, scale) {
  scale = scale || 1;
  var img = new Image();

  img.onload = function () {
    var dim = getBox(this.width * scale, this.height * scale);
    console.log("%c" + dim.string, dim.style + "background: url(" + url + "); background-size: " + (this.width * scale) + "px " + (this.height * scale) + "px; color: transparent;");
  };

  img.src = url;
};

window.rememberTemplateSettings = function () {
  const customer_id = $('input[name="customer_id"]').val();
  const key = "customer_" + customer_id + "_settings";
  if (localStorage.getItem(key)) {
    var settings = JSON.parse(localStorage.getItem(key));
    const template_id = $('input[name="template_id"]').val();
    const formData = $("#adForm").serializeArray();
    const queryString = JSON.stringify(formData);
    settings["template_" + template_id] = queryString;
    settings["last_template"] = template_id;
    localStorage.setItem(key, JSON.stringify(settings));
  }
};

window.windowStatusInterval = null;
window.checkStatus = function () {
  axios.post('/session-status', {}, {
    headers: {
      'Content-Type': 'application/json',
    }
  }).then(function (result) {

    let flashMessage = ' <div style="width: 100% !important;" class="alert alert-danger alert-dismissible fade show" role="alert">\n' +
      '                    <strong>Your session has expired, please re-login.</strong>\n' +
      '                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n' +
      '                        <span aria-hidden="true">&times;</span>\n' +
      '                    </button>\n' +
      '                </div>';

    if (result.data.status != 200) {
      // Guests are expected to get 401 from /session-status; don't show a false expiration banner.
      if (result.data.status === 401 && !document.getElementById('sidebar') && !window.__EMBED_TOKEN__) {
        return;
      }
      if (window.__EMBED_TOKEN__) {
        window.parent.postMessage(
          { type: 'embed:auth', status: 'TOKEN_EXPIRED' },
          '*'
        );
      }
      clearInterval(window.windowStatusInterval)
      //if opened model
      if ($('.modal.fade.show').length) {
        $('.modal.fade.show').find('.modal-content').prepend(flashMessage);
      } else {
        $('div#app').find('.c-main').prepend(flashMessage);
      }
    }
  }).catch(function () {
    // A failed poll is not an expired session; logging it would re-add the console error.
  });
}

window.forgetTemplateSettings = function (customer_id = "", template_id = "") {
  axios.delete('/user/color/reset').then((res) => {
    if (customer_id == "")
      customer_id = $('input[name="customer_id"]').val();
    const key = "customer_" + customer_id + "_settings";

    if (localStorage.getItem(key)) {

      if (template_id == "") {
        localStorage.removeItem(key);
      } else {
        // just clear settings for this particlar template
        var settings = JSON.parse(localStorage.getItem(key));
        if (settings) {
          settings["template_" + template_id + "_edited"] = '{}';
          settings["template_" + template_id + "_files"] = '{}';
          settings["template_" + template_id] = '[]';

          localStorage.setItem(key, JSON.stringify(settings));
        }

      }

    }

    if (localStorage.getItem("selected_files")) {
      localStorage.removeItem("selected_files");
    }

    if (localStorage.getItem("hero_image_position")) {
      localStorage.removeItem("hero_image_position");
    }

    for (var i = 0; i < 5; i++) {
      if (localStorage.getItem("image_position_" + i)) {
        localStorage.removeItem("image_position_" + i);
      }

    }

    var name = "file_ids";
    var value = "";
    var expires = "";
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  });
};

import Vue from "vue";
import store from "./store";
import router from './router'
import VueLazyload from 'vue-lazyload'
import vueCustomElement from 'vue-custom-element'
import VModal from 'vue-js-modal'

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "../../sass/includes/bootstrap-vue.scss"
import "toastr/build/toastr.css";

import contenteditable from 'vue-contenteditable'
export const bus = new Vue();

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueLazyload);
Vue.use(vueCustomElement);
Vue.use(VModal);
Vue.use(contenteditable)

Vue.component('DashboardPage', () => import('./components/DashboardPage.vue'))
Vue.component('BannerBuilder', () => import('./components/common/dashboard/BannerBuilder.vue'))
Vue.component('PromptGeneratorPage', () => import('./components/PromptGeneratorPage.vue'))
Vue.component('ProductDescriptionGeneratorPageV2', () => import('./components/ProductDescriptionGeneratorPageV2.vue'))
Vue.component('ThreeDRendersPage', require('./components/ThreeDRendersPage.vue').default);
Vue.component('ThreeDRendersV2Page', () => import('./components/ThreeDRendersV2Page.vue'));
Vue.component('VideoTable', () => import('./components/VideoTable.vue'))
Vue.component('UserNotification', () => import('./components/modules/user-notifications/UserNotification.vue'))
Vue.component('AnalyticsReportPublishQueue', () => import('./components/modules/user-notifications/AnalyticsReportPublishQueue.vue'))
Vue.component('FileBrowser', () => import('./components/modules/file-browser/FileBrowser.vue'))
Vue.component('LayoutFolderBrowser', () => import('./components/modules/layout-folder-browser/FileBrowser.vue'))
Vue.component('FileBrowserProductSelector', () => import('./components/modules/file-browser-product-selector/FileBrowser.vue'))
Vue.component('FileUploadImages', () => import('./components/modules/file-upload-images/UploadImages.vue'))
Vue.component('ShareImage', () => import('./components/ShareImage.vue'))
Vue.component('CatalogPage', () => import('./components/CatalogPage.vue'))
Vue.component('ShareVideo', () => import('./components/ShareVideo.vue'))
Vue.component('ShareProofVideo', () => import('./components/ShareProofVideo.vue'))
Vue.component('ShareProofGenerationProgress', () => import('./components/ShareProofGenerationProgress.vue'));
Vue.component('ProofsPage', () => import('./components/ProofsPage.vue'))
Vue.component('BriefsIndexPage', () => import('./components/briefs/BriefsIndexPage.vue'))
Vue.component('BriefsDetailPage', () => import('./components/briefs/BriefDetailPage.vue'))
Vue.component('BriefsWorkroomPage', () => import('./components/briefs/BriefWorkroomPage.vue'))
Vue.component('BriefsSharedPage', () => import('./components/briefs/BriefSharedPage.vue'))
Vue.component('ContentPlannerPage', () => import('./components/content-planner/ContentPlannerPage.vue'))
Vue.component('PulsePage', () => import('./components/pulse/PulsePage.vue'))
Vue.component('BriefVanityStartPage', () => import('./components/briefs/BriefVanityStartPage.vue'))
Vue.component('BriefSharedRequestStartPage', () => import('./components/briefs/BriefSharedRequestStartPage.vue'))
Vue.component('BriefVanityBuildPage', () => import('./components/briefs/BriefVanityBuildPage.vue'))
Vue.component('BriefVanitySubmittedPage', () => import('./components/briefs/BriefVanitySubmittedPage.vue'))
Vue.component('BriefIntakeConfirmationPage', () => import('./components/briefs/BriefIntakeConfirmationPage.vue'))
Vue.component('BriefShowcasePage', () => import('./components/briefs/BriefShowcasePage.vue'))
Vue.component('BriefIntakeExternalShell', () => import('./components/briefs/BriefIntakeExternalShell.vue'))
Vue.component('BriefsSlidesPrintPage', () => import('./components/briefs/BriefSlidesPrintPage.vue'))
Vue.component('NetworksPageV2', () => import('@backend/components/networks/NetworksPageV2.vue'));
Vue.component('ClipboardDrawer', () => import('./components/common/clipboard/ClipboardDrawer.vue'));
Vue.component('ClipboardTriggerButton', () => import('./components/common/clipboard/ClipboardTriggerButton.vue'));
Vue.component('DesignGalleryPage', () => import('@backend/components/networks/DesignGalleryPage.vue'));
Vue.component('TitleOptimizerPage', () => import('./components/TitleOptimizerPage.vue'));
Vue.component('SellSheetV2', () => import('./components/common/dashboard/SellSheetV2.vue'))

Vue.component('ProjectShareUpload', () => import('./components/ProjectShareUpload.vue'))
Vue.component('OutlineFieldsModal', require('./components/modules/layouts-page/OutlineFieldsModal.vue').default);
Vue.component('ExportTemplatesModal', require('./components/modules/layouts-page/Export/ExportTemplatesModal.vue').default);
Vue.component('NamingTableVariablesModal', require('./components/modules/layouts-page/modals/NamingTableVariablesModal.vue').default);
Vue.component('LayoutSettingsModalExportTab', require('./components/modules/layouts-page/LayoutSettingsModal/ExportTab.vue').default);
Vue.component('LayoutSettingsModalLayoutsTab', require('./components/modules/layouts-page/LayoutSettingsModal/LayoutsTab.vue').default);
Vue.component('ReplaceTextModal', require('./components/modules/layouts-page/modals/ReplaceTextModal.vue').default);
Vue.component('CopyAndResizeTemplateModal', require('./components/modules/layouts-page/modals/CopyAndResizeTemplateModal.vue').default);
Vue.component('BulkCopyAndResizeTemplatesModal', require('./components/modules/layouts-page/modals/BulkCopyAndResizeTemplatesModal.vue').default);
Vue.component('SwapTemplateModal', require('./components/modules/layouts-page/modals/SwapTemplateModal.vue').default);
Vue.component('MakeTemplateImageEditableModal', require('./components/modules/layouts-page/modals/MakeTemplateImageEditableModal.vue').default);
Vue.component('MakeEditableV2Modal', require('./components/modules/layouts-page/modals/MakeEditableV2Modal.vue').default);
Vue.component('TranslateTemplateImageModal', require('./components/modules/layouts-page/modals/TranslateTemplateImageModal.vue').default);
Vue.component('BatchTranslateTemplateImageModal', require('./components/modules/layouts-page/modals/BatchTranslateTemplateImageModal.vue').default);
Vue.component('TranslationSettingsModal', require('./components/common/translation-settings/TranslationSettingsModal.vue').default);
Vue.component('SaveAsTemplateModal', require('./components/modules/layouts-page/modals/design-gallery/SaveAsTemplateModal.vue').default);
Vue.component('AddToDesignGalleryModal', require('./components/modules/layouts-page/modals/design-gallery/AddToDesignGalleryModal.vue').default);
Vue.component('SelectStrategyImportFromPsd', require('./components/modules/layouts-page/modals/SelectStrategyImportFromPsd.vue').default);
Vue.component('SelectStrategyImportFromFig', require('./components/modules/layouts-page/modals/SelectStrategyImportFromFig.vue').default);
Vue.component('SelectStrategyImportFromIdml', require('./components/modules/layouts-page/modals/SelectStrategyImportFromIDML.vue').default);
Vue.component('MaskSettingsModal', require('./components/modules/layouts-page/modals/MaskSettingsModal.vue').default);
Vue.component('RenameJobModal', require('./components/modals/RenameJobModal.vue').default);
Vue.component('LayoutFolderBrowserModal', require('./components/modals/LayoutFolderBrowserModal.vue').default);
Vue.component('GenerateTemplateThumbnailModal', require('./components/modules/layouts-page/modals/GenerateTemplateThumbnailModal.vue').default);
Vue.component('WalmartShowPreview', require('./components/walmart/WalmartShowPreview.vue').default);
Vue.component('CatalogManagementModal', require('./components/modules/layouts-page/modals/CatalogManagementModal.vue').default);
Vue.component('CatalogLayoutsListsModal', require('./components/modules/layouts-page/modals/CatalogLayoutsListsModal.vue').default);
Vue.component('SimpleTableBuilderModal', require('./components/modules/layouts-page/modals/SimpleTableBuilderModal.vue').default);
Vue.component('PsdPreview', require('./components/modules/psd-layers/PSDPreview.vue').default)
Vue.component('FigmaPreview', require('../frontend/components/modules/figma-layers/FigmaPreview.vue').default);
Vue.component('IdmlPreview', require('./components/modules/idml-layers/IDMLPreview.vue').default);
Vue.component('CatalogsColumnsModal', require('./components/modules/layouts-page/modals/CatalogsColumnsModal.vue').default);
Vue.component('LayoutsFilterControls', require('./components/modules/layouts-page/LayoutsFilterControls.vue').default);
Vue.component('IconsSettingsModal', require('../frontend/components/modules/layouts-page/modals/IconsSettingsModal.vue').default);
Vue.component('ImportHyperlinks', require('./components/modules/layouts-page/modals/ImportHyperlinks.vue').default);
Vue.component('RenameLayoutModal', require('./components/modules/layouts-page/modals/RenameLayoutModal.vue').default);
Vue.component('FeedImportHeaderMapping', require('./components/modals/FeedImportHeaderMapping.vue').default);
Vue.component('ImportMappingsModal', require('./components/modules/layouts-page/modals/import-mappings/ImportMappingsModal.vue').default);
Vue.component('CompressionSettingsModal', require('./components/modules/file-browser/modals/CompressionSettingsModal.vue').default)
Vue.component('BrandColorsModal', require('./components/modules/layouts-page/modals/BrandColorsModal.vue').default);
Vue.component('CopyToLayoutModal', require('./components/modules/layouts-page/modals/CopyToLayoutModal.vue').default);
Vue.component('WalmartPreviewShare', require('./components/walmart/WalmartPreviewShare.vue').default);
Vue.component('ImportImageModal', require('./components/modules/layouts-page/modals/ImportImageModal.vue').default);
Vue.component('ImageSegmentationPreviewModal', require('./components/modules/layouts-page/modals/ImageSegmentationPreviewModal.vue').default);
Vue.component('AiAgentSidebar', require('./components/AiAgentSidebar.vue').default);
Vue.component('AiExtractClaimsModal', require('./components/modules/layouts-page/modals/AiExtractClaimsModal.vue').default);
Vue.component('AdditionalMetaproperties', require('@frontend/components/bynder/AdditionalMetaproperties.vue').default);
Vue.component('BynderMetadataModal', require('@frontend/components/modals/BynderMetadataModal.vue').default);
Vue.component('CatalogShareModal', require('@frontend/components/modals/CatalogShareModal.vue').default);
Vue.component('AddFromGalleryTemplateModal', require('@frontend/components/modals/AddFromGalleryTemplateModal.vue').default);
Vue.component('LibraryPage', () => import('@frontend/components/LibraryPage.vue'));

/**
 * Web Components for Vue 2
 * @see https://github.com/karol-f/vue-custom-element
 */
Vue.customElement('custom-template-size-modal-ce', require('./components/modules/layouts-page/CustomTemplateSizeModal.vue').default)
Vue.customElement('background-maker-ce', require('./components/BackgroundMaker.vue').default)
Vue.customElement('layout-sidebar-ce', require('./components/modules/layouts-page/LayoutSidebar.vue').default)
Vue.customElement('background-theme-color-ce', require('./components/modules/layouts-page/BackgroundThemeColor.vue').default)
Vue.customElement('svg-preview-ce', require('./components/modules/svg-editor/SVGEditor.vue').default)
Vue.customElement('upload-modal-ce', require('./components/modals/UploadModal.vue').default)
Vue.customElement('layout-theme-modal-ce', require('./components/modals/LayoutThemeModal.vue').default)
Vue.customElement('keyword-analytics-ce', require('./components/KeywordAnalytics.vue').default)
Vue.customElement('product-descriptions-compare-ce', require('./components/ProductDescriptionsCompare.vue').default)
Vue.customElement('layout-folder-select-ce', require('./components/modules/layouts-page/LayoutFolderSelect.vue').default)
Vue.customElement('svg-preview-messages-ce', require('./components/modules/svg-editor/SVGEditorMessages.vue').default)
Vue.customElement('walmart-folder-tree', require('@frontend/components/common/atoms/WalmartFolderTreeSelect/WalmartFolderTree.vue').default)
Vue.customElement('walmart-asset-selector', require('@frontend/components/WalmartAssetSelector.vue').default)
Vue.customElement('walmart-reports', require('@frontend/components/walmart/WalmartReports.vue').default)
Vue.customElement('import-histories-table', require('@frontend/components/ImportHistoriesTable.vue').default)
Vue.customElement('recent-feed-history-dropdown', require('@frontend/components/RecentFeedHistoryDropdown.vue').default)
Vue.customElement('transformations-modal', require('@frontend/components/modules/edit-page/import/transformations/TransformationsModal.vue').default)
Vue.customElement('bynder-metadata-modal', require('@frontend/components/modals/BynderMetadataModal.vue').default)
Vue.customElement('product-list-form', require('@frontend/components/modules/product-list/ProductListForm.vue').default)
Vue.customElement('product-id-list-form', require('@frontend/components/modules/product-id-list/ProductIdListForm.vue').default)
Vue.customElement('additional-metaproperties', require('@frontend/components/bynder/AdditionalMetaproperties.vue').default)
Vue.customElement('meta-fields', require('@frontend/components/optimizely/MetaFields.vue').default)
Vue.customElement('btn-save-selection-as', require('@frontend/components/BtnSaveSelectionAs.vue').default)
Vue.customElement('global-video-screen-recording', require('@frontend/components/modules/video-screen-recording/global-video-screen-recording.vue').default);
Vue.customElement('global-video-screen-recording-popup', require('@frontend/components/modules/video-screen-recording/global-video-screen-recording-popup.vue').default);
Vue.customElement('analytics-history-group-modal', require('./components/modules/analytics-history/modals/AnalyticsHistoryGroupModal.vue').default);
Vue.customElement('show-ruler-component-ce', require('./components/modules/layouts-page/ShowRulerComponent.vue').default);
Vue.customElement('edit-mode-selector-ce', require('./components/modules/layouts-page/EditModeSelector.vue').default);
Vue.customElement('sync-layout-toggle-ce', require('./components/modules/layouts-page/EditorControl/components/SyncLayoutToggle.vue').default);
Vue.customElement('copy-assets-modal', require('@frontend/components/modules/file-browser/modals/CopyAssetsModal.vue').default);
Vue.customElement('briefs-tab-ce', require('@frontend/components/modules/file-browser/modals/BriefsTabContentView.vue').default);
Vue.customElement('stock-source-pane-ce', require('@frontend/components/modules/file-browser/modals/StockSourcePane.vue').default);
Vue.customElement('stock-source-controls-ce', require('@frontend/components/modules/file-browser/modals/StockSourceControls.vue').default);
Vue.customElement('theme-background-pane-ce', require('@frontend/components/modules/file-browser/modals/ThemeBackgroundPane.vue').default);
Vue.customElement('files-pane-ce', require('@frontend/components/modules/file-browser/modals/FilesPane.vue').default);
Vue.customElement('feed-import-file-browser-modal', require('@frontend/components/modules/file-browser/modals/FeedImportFileBrowserModal.vue').default);
Vue.customElement('optix-lab-analyzer', require('./components/OptixLabAnalyzer.vue').default);
Vue.component('ImageAnalyzer', require('@frontend/components/common/dashboard/AnalyzeImages.vue').default);
Vue.component('PdpAnalyzer', require('@frontend/components/common/dashboard/PDPAnalysis.vue').default);
Vue.component('ShareOfShelf', require('@frontend/components/common/dashboard/ShareOfShelf.vue').default);
Vue.component('ProductReportsDashboard', require('@frontend/components/common/dashboard/ProductReportsDashboard.vue').default);
Vue.customElement('select-image-to-analyse-modal', require('./components/modules/file-browser/modals/SelectImagesToAnalyseModal.vue').default);
Vue.customElement('banner-builder-layout-sidebar', require('./components/common/dashboard/banner-builder/BannerBuilderLayoutSidebar.vue').default);
Vue.customElement('banner-builder-templates', require('./components/common/dashboard/banner-builder/Templates.vue').default);
Vue.customElement('setup-connection-modal', require('@frontend/components/modals/SetupConnectionModal.vue').default);
Vue.customElement('ai-search-bar', require('@frontend/components/common/dashboard/banner-builder/AiSearchBar.vue').default);
Vue.component('ShelfPlanogram', require('@frontend/components/ShelfPlanogram.vue').default);
Vue.customElement('background-picker', require('@frontend/components/display-builder/BackgroundPicker.vue').default);
Vue.customElement('display-builder-options', require('@frontend/components/display-builder/DisplayBuilderOptions.vue').default);
Vue.customElement('versions-layouts-modal', require('@frontend/components/display-builder/VersionsLayoutsModal.vue').default);
Vue.customElement('new-version-modal', require('@frontend/components/display-builder/NewVersionModal.vue').default);
Vue.customElement('confirm-dialog', require('@frontend/components/display-builder/ConfirmDialog.vue').default);
Vue.customElement('display-builder-publish-modal', require('@frontend/components/display-builder/PublishModal.vue').default);
Vue.customElement('layout-animation-settings-modal', require('@frontend/components/modules/layout-animation/LayoutAnimationSettingsModal.vue').default)


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('CommerceVisibilityReport', () => import('@/analytics/components/CommerceVisibilityReport.vue'));

const app = new Vue({
  store,
  router,
});

router.onReady(() => {
  app.$mount("#app")
})

Vue.prototype.$store = store
Vue.prototype.$myToast = {
  success: () => {
    console.log("success");
  },
  failed: () => {
    console.log("failed");
  },
};


$(document).ready(function () {
  const checkStatus = $('body').attr('data-check-status');
  if (checkStatus !== undefined) {
    window.windowStatusInterval = setInterval('window.checkStatus()', 30000);
    $('#sidebar').on('classtoggle', function (event) {
      let isSideBarOpen = $('#sidebar').hasClass('c-sidebar-lg-show') || $('#sidebar').hasClass('c-sidebar-show') ? 'open' : 'closed';
      let variant = $('#sidebar').hasClass('c-sidebar-minimized') ? 'c-sidebar-minimized' : '';

      if ($('#sidebar').hasClass('custom-logo')) {
        if ($('#sidebar').hasClass('padding-adjustment')) {
          $("#sidebar").removeClass("padding-adjustment");
        }

        if ($('#sidebar').hasClass('c-sidebar-minimized')) {
          $("#sidebar").addClass("padding-adjustment");
        }
      }

      axios(`/toggle-options?sidebarState=${isSideBarOpen}&sidebarMinimizeState=${variant}`);
    });
  }
});

$("#showMe").click((e) => {
  e.preventDefault();

  if ($("#password").attr("type") === "password") {
    $("#showMe").removeClass("bi-eye").addClass("bi-eye-slash");
    $("#password").attr('type', 'text');
  } else if ($("#password").attr("type") === 'text') {
    $("#showMe").removeClass("bi-eye-slash").addClass("bi-eye");
    $("#password").attr("type", "password");
  }
})

$("#showMeConfirmation").click((e) => {
  e.preventDefault();

  if ($("#password_confirmation").attr("type") === "password") {
    $("#showMeConfirmation").removeClass("bi-eye").addClass("bi-eye-slash");
    $("#password_confirmation").attr('type', 'text');
  } else if ($("#password_confirmation").attr("type") === 'text') {
    $("#showMeConfirmation").removeClass("bi-eye-slash").addClass("bi-eye");
    $("#password_confirmation").attr("type", "password");
  }
})


$(document).ready(() => {
  // Triggers when existing sidebar events are called
  $('#sidebar').on('classtoggle', () => {
    if ($('#sidebar').hasClass('c-sidebar-minimized')) {
      if ($('.c-sidebar-nav').hasClass('ps')) {
        $('.c-sidebar-nav').removeClass('ps');
      }
    }
  });

  const gridViewCompany = $("#grid-view-company");
  gridViewCompany.multipleSelect();
});

function setupMinimizedSidebarDropdownScroll() {
  const sidebar = document.getElementById('sidebar');
  if (!sidebar) return;

  const updateDropdownMaxHeight = (dropdown) => {
    const items = dropdown.querySelector(':scope > .c-sidebar-nav-dropdown-items');
    if (!items) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const padding = 8;
        const viewportHeight = window.innerHeight;
        const itemsRect = items.getBoundingClientRect();
        const availableBelow = viewportHeight - itemsRect.top - padding;
        const availableAbove = itemsRect.top - padding;
        const contentHeight = items.scrollHeight;

        items.style.top = '0px';

        let maxHeight = Math.max(120, availableBelow);

        if (contentHeight > availableBelow && availableAbove > 0) {
          const shiftUp = Math.min(availableAbove, contentHeight - availableBelow);
          items.style.top = `${-shiftUp}px`;
          maxHeight = Math.max(120, viewportHeight - (itemsRect.top - shiftUp) - padding);
        }

        items.style.maxHeight = `${maxHeight}px`;
      });
    });
  };

  const clearDropdownMaxHeight = (dropdown) => {
    const items = dropdown.querySelector(':scope > .c-sidebar-nav-dropdown-items');
    if (!items) return;
    items.style.maxHeight = '';
    items.style.top = '';
  };

  sidebar.querySelectorAll('.c-sidebar-nav > .c-sidebar-nav-dropdown').forEach((dropdown) => {
    dropdown.addEventListener('mouseenter', () => {
      if (!sidebar.classList.contains('c-sidebar-minimized')) return;
      updateDropdownMaxHeight(dropdown);
    });
    dropdown.addEventListener('mouseleave', () => {
      clearDropdownMaxHeight(dropdown);
    });
  });

  window.addEventListener('resize', () => {
    if (!sidebar.classList.contains('c-sidebar-minimized')) return;
    sidebar.querySelectorAll('.c-sidebar-nav > .c-sidebar-nav-dropdown:hover').forEach(updateDropdownMaxHeight);
  });
}

function setupLoginScreenPicker() {
  const menu = document.querySelector(".login-screen-menu");
  if (!menu) {
    return;
  }

  const url = menu.dataset.loginScreenUrl;
  const current = menu.querySelector(".login-screen-current");

  menu.querySelectorAll(".login-screen-option").forEach((option) => {
    option.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const screen = option.dataset.loginScreen;
      if (option.classList.contains("is-selected")) {
        return;
      }

      try {
        const response = await axios.post(url, { screen });

        menu.querySelectorAll(".login-screen-option").forEach((item) => {
          item.classList.toggle("is-selected", item === option);
        });

        if (current) {
          current.textContent = response.data.text;
        }

        if (typeof toastr !== "undefined") {
          toastr.success(`You'll land on ${response.data.text} next time you log in.`);
        }
      } catch (error) {
        if (typeof toastr !== "undefined") {
          toastr.error(
            error?.response?.data?.message || "Could not save your login screen."
          );
        }
      }
    });
  });
}

$(document).ready(() => {
  setupMinimizedSidebarDropdownScroll();

  $('.c-sidebar-nav').hover(
    () => {
      if ($('#sidebar').hasClass('c-sidebar-minimized')) {
        if ($('.c-sidebar-nav').hasClass('ps')) {
          $('.c-sidebar-nav').removeClass('ps');
        }
      }
    }
  );

  setupLoginScreenPicker();

  const headerDropdown = document.getElementById("headerDropdown");
  if (headerDropdown) {
    headerDropdown.addEventListener("shown.coreui.dropdown", () => {
      $(".bi").addClass("bi__show");
    });

    headerDropdown.addEventListener("hidden.coreui.dropdown", () => {
      $(".bi").removeClass("bi__show");
    });
  }
});

// This function is also on resources/js/analytics/app.js PLEASE MANTAIN BOTH
window.applyImageOrderSalsify = async function (reportId, revert = false){

        if (typeof toastr !== 'undefined') {
          toastr.info('Applying image order on Salsify...');
        }

        try {

            let url = `/analytics-history/${reportId}/reorder-images-salsify`;

            if (revert)
              url += '?revert=true';

            const response = await axios.get(url);

            if (response.data.success) {
                const rerunData = response.data.data;
  
                if (typeof toastr !== 'undefined') {
                    toastr.success(response.data.message);
                }

            } else {
                if (typeof toastr !== 'undefined') {
                    toastr.error(response.data.message || 'Failed to load report data');
                }
            }
        } catch (error) {
            console.error('Error loading rerun data:', error);
            if (typeof toastr !== 'undefined') {
                toastr.error('Failed to load report data');
            }
        }
}

// This function is also on resources/js/analytics/app.js PLEASE MANTAIN BOTH
window.applyImageOrderSalsify2 = async function (reportId, positionsToUse, targetSize = 11, productName){
  if (typeof toastr !== 'undefined') {
    toastr.info('Applying image order on Salsify to ' + productName + '...');
  }

  try {

      const response = await axios.post(
          `/analytics-history/${reportId}/reorder-images-salsify2`,
          {
              images: positionsToUse,
              targetSize: targetSize
          }
      );
  
      if (response.data.success) {
          const rerunData = response.data.data;

          if (typeof toastr !== 'undefined') {
              let message = response.data.message
              message = message.replace(
                'The product was updated',
                `The product ${productName} was updated`
              );
              toastr.success(message);
          }
      } else {
          if (typeof toastr !== 'undefined') {
              toastr.error(response.data.message || 'Failed to load report data');
          }
      }

  } catch (error) {
      console.error('Error loading rerun data:', error);
      if (typeof toastr !== 'undefined') {
          toastr.error('Failed to load report data');
      }
  }
}
